/*
 Copyright (C) 2017 3NSoft Inc.

 This program is free software: you can redistribute it and/or modify it under the terms of the GNU General Public License as published by the Free Software Foundation, either version 3 of the License, or (at your option) any later version.

 This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with this program. If not, see <http://www.gnu.org/licenses/>. */

import * as Modules from './common/modules';
import * as Router from './common/router';
import * as Config from './common/config';

const appModuleDependencies = Modules.appModuleDependencies;
const app = angular.module('3nClient', appModuleDependencies);

app.config(['$mdThemingProvider', 'ngMdIconServiceProvider', 'ngQuillConfigProvider', Config.configApp]);
app.config(['$stateProvider', '$urlRouterProvider', Router.router]);
